import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ax from "./axios.js";
import VueSimpleAlert from "vue-simple-alert";
import BlockUI from "vue-blockui";
import VeeValidate from "vee-validate";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
Vue.use(BlockUI);
Vue.use(VeeValidate);
Vue.use(VueSimpleAlert);
Vue.prototype.axios = ax;
Vue.mixin({
  data() {
    return {
      appenv: {
        key: "ABC",
        secret: "123",
        website: "https://harbourcitycollege.edu.gh/",
        hostedurl: "https://africanplantbreeders.ug.edu.gh/webapp",
        // baseurl:'http://localhost/apba/api',
        baseurl: "https://harbourcitycollege.edu.gh/app/eazischool/api",
      },
    };
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
